import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Box, Label } from 'fw/components';
import { DateRangePicker, Form } from 'fw/forms';
import DateRangeHelper from 'fw/forms/helpers/DateRangeHelper'
import * as Modals from 'fw/globals/Modals'

class DateRangePickerDemo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			form: {
				default: null,
				required: null,
				disabled: null,
				presetCustom: { option: "custom", start: "05 May 2017", end: "31 May 2017" },
				presetRange: new DateRangeHelper().lastYear()
			}
		};
	}

	onChange = (form) => {
		this.setState({ form });
	}

	onSubmit = () => {
		Modals.alert(JSON.stringify(this.state.form));
	}

	render() {
		return (
			<Box title="DateRangePicker">
				<Form
					onChange={this.onChange}
					values={this.state.form}
					onSubmit={this.onSubmit}>
					<Row>
						<Col md={6}>
							<Label>Default</Label>
							<DateRangePicker name="default" />
						</Col>
						<Col md={6}>
						</Col>
					</Row>
					<Row>
						<Col md={6}>
							<Label required>Required</Label>
							<DateRangePicker name="required" required />
						</Col>
						<Col md={6}>
							<Label>Disabled</Label>
							<DateRangePicker name="disabled" disabled />
						</Col>
					</Row>
					<Row>
						<Col md={6}>
							<Label>Preset Custom</Label>
							<DateRangePicker name="presetCustom" />
						</Col>
						<Col md={6}>
							<Label>Preset Range</Label>
							<DateRangePicker name="presetRange" />
						</Col>
					</Row>
					<hr />
					<Button id="btnSubmit" type="submit" className="pull-right">Submit</Button>
				</Form>
			</Box>
		)
	}
}

export default DateRangePickerDemo;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/DatePickers/DateRangePickerDemo.js